import React, { useEffect, useState } from "react"
import { Row, Col, Button, Card, Modal, Spin, message } from "antd"
import StyledSection from "./products-section-styles"
import ProductModal from "./product-modal"
import { Link } from "gatsby"
import useParentCategories from "../../utils/useParentCategories"
import axios from "axios"

const { Meta } = Card

const ChoosingSection = ({ products }) => {
  const [loading, setloading] = useState(false)
  const [filteredProducts, setfilteredProducts] = useState(products)
  const [subCategories, setSubCategories] = useState([])
  const [extraSubCategories, setExtraSubCategories] = useState([])
  const { categories } = useParentCategories()
  const [searchValue, setSearchValue] = useState("")

  const url = `${process.env.GATSBY_API_URL}/wp-json/wc/v3/products?consumer_key=${process.env.GATSBY_CONSUMER_KEY}&consumer_secret=${process.env.GATSBY_CONSUMER_SECRET}`
  const catUrl = `${process.env.GATSBY_API_URL}/wp-json/wc/v3/products/categories?consumer_key=${process.env.GATSBY_CONSUMER_KEY}&consumer_secret=${process.env.GATSBY_CONSUMER_SECRET}`

  const [visible, setVisible] = useState(false)
  const [currId, setcurrId] = useState(0)
  const [searchVisibility, setSearchVisibility] = useState(false)

  const mainCategoryChange = async e => {
    const id = e.target.value
    console.log(id)
    if (id === "") {
      setfilteredProducts(products)
      setSubCategories([])
      setExtraSubCategories([])
      return
    }
    setloading(true)
    axios
      .get(`${url}&category=${id}`)
      .then(({ data }) => {
        setfilteredProducts(data)
        setloading(false)

        axios
          .get(`${catUrl}&parent=${id}`)
          .then(({ data }) => {
            setSubCategories(data)
          })
          .catch(error => {
            // handle error
            console.log(error)
            setloading(false)
          })
      })
      .catch(error => {
        // handle error
        console.log(error)
        setloading(false)
      })
  }

  const subCategoryChange = async e => {
    let id = e.target.value
    setloading(true)
    axios
      .get(`${url}&category=${id}`)
      .then(({ data }) => {
        setfilteredProducts(data)
        setloading(false)

        axios
          .get(`${catUrl}&parent=${id}`)
          .then(({ data }) => {
            setExtraSubCategories(data)
            id = ""
          })
          .catch(error => {
            // handle error
            console.log(error)
            setloading(false)
          })
      })
      .catch(error => {
        // handle error
        console.log(error)
        setloading(false)
      })
  }
  const extraSubCategoryChange = async e => {
    let id = e.target.value
    setloading(true)
    axios
      .get(`${url}&category=${id}`)
      .then(({ data }) => {
        setfilteredProducts(data)
        setloading(false)
      })
      .catch(error => {
        // handle error
        console.log(error)
        setloading(false)
      })
  }

  const SearchProducts = e => {
    const res = products.filter(proj =>
      Object.values(proj)
        .join(" ")
        .toLocaleLowerCase()
        .includes(searchValue.toLocaleLowerCase())
    )
    setfilteredProducts(res)
  }

  return (
    <StyledSection>
      <h1>Do You Need Help Choosing?</h1>
      <Row gutter={[32, 16]} justify="center" align="middle">
        <Col xs={24} sm={12} md={6}>
          <select onChange={mainCategoryChange} name="main-categories">
            <option value="" selected>
              Select a Category
            </option>
            {categories.map(item => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <select
            className="select-css"
            name="sub-categories"
            onChange={subCategoryChange}
          >
            <option value="" selected>
              Select a Category
            </option>
            {subCategories.map(cat => (
              <option value={cat.id} key={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <select
            className="select-css"
            name="ext-sub-categories"
            onChange={extraSubCategoryChange}
          >
            <option value="" selected>
              Select a Category
            </option>
            {extraSubCategories.map(cat => (
              <option value={cat.id} key={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <form className="" onSubmit={SearchProducts}>
            {searchVisibility ? (
              <input
                type="text"
                className="input-css"
                onKeyDown={SearchProducts}
                onChange={e => {
                  setSearchValue(e.target.value)
                }}
                placeholder="search a product*"
              />
            ) : (
              <button
                className="styled-button"
                type="submit"
                onClick={() => setSearchVisibility(true)}
              >
                Search
              </button>
            )}
          </form>
        </Col>
      </Row>

      {loading ? (
        <Row justify="center">
          <Spin size="large" />
        </Row>
      ) : (
        <Row gutter={16} style={{ marginTop: "2rem" }}>
          {filteredProducts.slice(0, 4).map(product => (
            <React.Fragment key={product.id}>
              <Col xs={24} sm={24} md={6}>
                <Card
                  onClick={() => {
                    setVisible(true)
                    setcurrId(product.id)
                  }}
                  hoverable
                  className="card"
                  cover={<img alt="product" src={product.images[0].src} />}
                >
                  <Meta title={product.name} />
                </Card>
              </Col>
            </React.Fragment>
          ))}
        </Row>
      )}

      <Modal
        centered
        width={1000}
        centered
        visible={visible}
        onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <ProductModal id={currId} products={products} />
      </Modal>
      <Link to="/products">
        <Button style={{ marginTop: "1rem" }}>Load More</Button>
      </Link>
    </StyledSection>
  )
}

export default ChoosingSection
